import { v4 as uuid } from "uuid";
import { RegionEntity } from "../region";
import { SiteAssignmentEntity, SiteAssignmentStrategy, SiteAssignmentType } from "../site-assignment";
import { SiteEntity } from "../site";
import { SiteAssignmentCompanyAssocEntity, SiteAssignmentSiteAssocEntity } from "../site-assignment-assoc";
import { TransportCategory } from "../transport-category";

interface StrategyStep {
  setStrategy: (value: SiteAssignmentStrategy) => TypeStep;
}

interface TypeStep {
  setType: (value: SiteAssignmentType) => CategoryStep;
}

interface CategoryStep {
  setCategory: (value: TransportCategory) => SiteStep;
}

interface SiteStep {
  setSite: (value: SiteEntity | string) => RegionStep;
}

interface RegionStep {
  setRegion: (value: RegionEntity | string) => SiteAssignmentBuilder;
}

export class SiteAssignmentBuilder
  implements StrategyStep, TypeStep, CategoryStep, SiteStep, RegionStep {
  id: string;
  strategy!: SiteAssignmentStrategy;
  type!: SiteAssignmentType;
  category!: TransportCategory;
  siteId!: string;
  regionId!: string;
  companyAssocs?: SiteAssignmentCompanyAssocEntity[] = [];
  siteAssocs?: SiteAssignmentSiteAssocEntity[] = [];
  createDttm?: number = undefined;
  lastModifiedDttm?: number = undefined;

  private constructor(id: string | undefined = uuid()) {
    this.id = id;
  }

  static builder(id: string | undefined = uuid()): StrategyStep {
    return new SiteAssignmentBuilder(id);
  }

  setStrategy(value: SiteAssignmentStrategy): TypeStep {
    this.strategy = value;
    return this;
  }

  setType(value: SiteAssignmentType): CategoryStep {
    this.type = value;
    return this;
  }

  setCategory(value: TransportCategory): SiteStep {
    this.category = value;
    return this;
  }

  setSite(value: SiteEntity | string): RegionStep {
    if (typeof value === "string") {
      this.siteId = value;
    } else {
      this.siteId = value.id;
    }
    return this;
  }

  setRegion(value: RegionEntity | string): SiteAssignmentBuilder {
    if (typeof value === "string") {
      this.regionId = value;
    } else {
      this.regionId = value.id;
    }
    return this;
  }

  setCompanyAssocs(
    value: SiteAssignmentCompanyAssocEntity[] | undefined
  ): SiteAssignmentBuilder {
    this.companyAssocs = value;
    return this;
  }

  setSiteAssocs(
    value: SiteAssignmentSiteAssocEntity[] | undefined
  ): SiteAssignmentBuilder {
    this.siteAssocs = value;
    return this;
  }

  setCreateDttm(dttm: number): SiteAssignmentBuilder {
    this.createDttm = dttm;
    return this;
  }

  setLastModifiedDttm(dttm: number): SiteAssignmentBuilder {
    this.lastModifiedDttm = dttm;
    return this;
  }

  build(): SiteAssignmentEntity {
    const entity = new SiteAssignmentEntity();
    entity.id = this.id;
    entity.strategy = this.strategy;
    entity.type = this.type;
    entity.category = this.category;
    entity.siteId = this.siteId;
    entity.regionId = this.regionId;
    entity.companyAssocs = this.companyAssocs;
    entity.siteAssocs = this.siteAssocs;
    entity.createDttm = this.createDttm;
    entity.lastModifiedDttm = this.lastModifiedDttm;
    return entity;
  }
}
